<template>
  <authorization permissionKey="configuration_diagnostic_hypothesis" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Hipótese diagnóstica
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/hipotese-diagnostica">CID</v-tab>
            <v-tab to="/configuracoes/hipotese-diagnostica/local">Local</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "DiagnosticHypothesisConfig",
  };
</script>

<style lang="sass" scoped></style>
